var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"m13.487 4.375.028.028.083.085 5.826 5.91 1.575 1.592-1.569 1.597-5.956 6.037a1.11 1.11 0 0 1-1.569.01 1.133 1.133 0 0 1-.011-1.596l4.867-4.939L4.1 13.1a1.1 1.1 0 0 1-.12-2.194l.12-.006h12.681l-4.86-4.931a1.127 1.127 0 0 1 0-1.583c.429-.435 1.13-.44 1.566-.011z","fill":"#000","fill-rule":"evenodd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }